function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.5 18C10.5 18.825 9.825 19.5 9 19.5C8.175 19.5 7.5 18.825 7.5 18C7.5 17.175 8.175 16.5 9 16.5C9.825 16.5 10.5 17.175 10.5 18ZM9 10.5C8.175 10.5 7.5 11.175 7.5 12C7.5 12.825 8.175 13.5 9 13.5C9.825 13.5 10.5 12.825 10.5 12C10.5 11.175 9.825 10.5 9 10.5ZM9 4.5C8.175 4.5 7.5 5.175 7.5 6C7.5 6.825 8.175 7.5 9 7.5C9.825 7.5 10.5 6.825 10.5 6C10.5 5.175 9.825 4.5 9 4.5ZM15 7.5C15.825 7.5 16.5 6.825 16.5 6C16.5 5.175 15.825 4.5 15 4.5C14.175 4.5 13.5 5.175 13.5 6C13.5 6.825 14.175 7.5 15 7.5ZM15 10.5C14.175 10.5 13.5 11.175 13.5 12C13.5 12.825 14.175 13.5 15 13.5C15.825 13.5 16.5 12.825 16.5 12C16.5 11.175 15.825 10.5 15 10.5ZM15 16.5C14.175 16.5 13.5 17.175 13.5 18C13.5 18.825 14.175 19.5 15 19.5C15.825 19.5 16.5 18.825 16.5 18C16.5 17.175 15.825 16.5 15 16.5Z",
  fill: "#003E72"
});

function SvgDrag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default __webpack_public_path__ + "static/media/drag.02172714.svg";
export { ForwardRef as ReactComponent };